import actions from "~/shared/actions";

export const defaultState = [];

export default function njordUtbetalingsoversiktReducer(state = defaultState, action) {
	switch (action.type) {
		case actions.GET_NJORD_UTBETALINGSOVERSIKT_RESPONSE: {
			const { policyNumber, utbetalingsoversikt } = action.data;

			return Array.from(state)
				.filter((p) => p.polisenummer !== policyNumber)
				.concat({ ...utbetalingsoversikt, polisenummer: policyNumber });
		}
		default:
			return state;
	}
}
